import axios from "axios";
//import accessToken from "./jwt-token-access/accessToken";

//pass new generated access token here
//const token = accessToken;

//apply base url for axios
import accessToken from "../jwt-token-access/accessToken";

//pass new generated access token here
const token = accessToken;

//apply base url for axios
const API_ACCOUNTS_URL = process.env.REACT_APP_ACCOUNT_SERVICE_URL || "http://localhost:8000/api/v1";




const axiosApi = axios.create({
  baseURL: API_ACCOUNTS_URL,
  headers: { 
    'Content-Type': 'application/json',
    'Accept': 'application/json'

   }
  
});


axiosApi.defaults.headers.common["Authorization"] = token;



//axios.defaults.baseURL = API_PURCHASES_URL;


// ----------------------------------------------------------------------
// 🚀 SOLUTION OPTIMALE : INTERCEPTEUR DE REQUÊTE
// ----------------------------------------------------------------------

axiosApi.interceptors.request.use(
  (config) => {
    try {
      // 1. Lire la valeur la plus récente de localStorage
      const storedUser = localStorage.getItem("authUser");
      let currentToken = null;

      if (storedUser) {
        const { access_token } = JSON.parse(storedUser) || {};
        currentToken = access_token;
      }

      // 2. Si un token existe, l'ajouter à l'en-tête de la requête
      if (currentToken) {
        config.headers.Authorization = `Bearer ${currentToken}`;
      } else {
        // Optionnel : Supprimer l'en-tête si l'utilisateur est déconnecté
        delete config.headers.Authorization;
      }
    } catch (error) {
      console.error("Erreur lors de l'ajout du token à l'intercepteur:", error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ----------------------------------------------------------------------
// Intercepteur de réponse (Gestion des erreurs 401)
// ----------------------------------------------------------------------

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    /*if (error.response && error.response.status === 401) {
      console.error("Erreur 401: Token expiré. Déconnexion utilisateur.");
      // 🚨 Ici, vous devez déclencher une action Redux de déconnexion globale
      // (ex: en utilisant un store injecté ou en lançant une erreur spécifique).
    }*/
    return Promise.reject(error);
  }
);

/*
axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);
*/

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}


export async function patch(url, data, config = {}) {
  return axiosApi
    .patch(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}
